import { useState, useEffect, useCallback } from "react";
import useLangHook from "hooks/useLang";
import i18n from "i18n";
const _i18n = i18n.t;

function getDefaultSorting(
  defaultTableData,
  columns,
  latestsortField = "",
  latestsortOrder = "",
  lang
) {
  const checkFilterColumn = columns.filter((column) => column.sortbyOrder);
  if (checkFilterColumn.length === 0 && latestsortField === "")
    return defaultTableData;
  const sorted = [...defaultTableData].sort((a, b) => {
    const filterColumn = columns.filter((column) => column.sortbyOrder);

    // Merge all array objects into single object and extract accessor and sortbyOrder keys
    let { accessor = "id", sortbyOrder = "asc" } = Object.assign(
      {},
      ...filterColumn
    );

    if (latestsortField)
      [accessor, sortbyOrder] = [latestsortField, latestsortOrder];
    if (a[accessor] === null) return 1;
    if (b[accessor] === null) return -1;
    if (a[accessor] === null && b[accessor] === null) return 0;

    const ascending = _i18n(a[accessor])
      .toString()
      .localeCompare(_i18n(b[accessor]).toString(), lang, {
        numeric: Number.isInteger(_i18n(a[accessor])),
      });

    return sortbyOrder === "asc" ? ascending : -ascending;
  });
  return sorted;
}

export const useSortableTable = (data, columns) => {
  const [tableData, setTableData] = useState(data);
  const [latestsortField, setLatestsortField] = useState("");
  const [latestsortOrder, setLatestsortOrder] = useState("");
  const { selectedLang } = useLangHook();
  const lang = selectedLang[0].code;

  useEffect(() => {
    setTableData(
      getDefaultSorting(data, columns, latestsortField, latestsortOrder, lang)
    );
  }, [data, columns, latestsortField, latestsortOrder]);

  const handleSorting = useCallback(
    (sortField, sortOrder, sortable = true) => {
      if (!sortable) return;
      if (sortField) {
        const sorted = [...tableData].sort((a, b) => {
          if (a[sortField] === null) return 1;
          if (b[sortField] === null) return -1;
          if (a[sortField] === null && b[sortField] === null) return 0;
          return (
            _i18n(a[sortField])
              .toString()
              .localeCompare(_i18n(b[sortField]).toString(), lang, {
                numeric: Number.isInteger(_i18n(a[sortField])),
              }) * (sortOrder === "asc" ? 1 : -1)
          );
        });
        setTableData(sorted);
        setLatestsortField(sortField);
        setLatestsortOrder(sortOrder);
      }
    },
    [tableData, lang]
  );

  return [tableData, handleSorting];
};
